// extracted by mini-css-extract-plugin
module.exports = {"user-type":"UserType_user-type__1Mhos","size__small":"UserType_size__small__3dMRJ","size__large":"UserType_size__large__2AQ8R"};